module.exports = __webpack_public_path__ + "img/code.5fd5d83d.png";